import { sendAsJson } from "../../components/core/ajax";
import { getUser } from "../../components/core/user";

// TODO: Hay que crear el cargando y qutiar esto.
// Además, ahora solo funciona en la parte vieja

declare let Imserso:
  | {
      loadingModalHide: () => void;
      loadingModalShow: () => void;
    }
  | undefined;

/** Muestra el modal cargando. */
function showLoading() {
  if (typeof Imserso !== "undefined") {
    try {
      $("#ims-accept-terms-btn").prop("disabled", true);
      Imserso.loadingModalShow();
    } catch {
      /* */
    }
  }
}

/** Oculta el modal cargando. */
function hideLoading() {
  if (typeof Imserso !== "undefined") {
    try {
      $("#ims-accept-terms-btn").prop("disabled", false);
      Imserso.loadingModalHide();
    } catch {
      /* */
    }
  }
}

/**
 * Inicializa el compomente.
 */
export default function initialize(): void {
  const user = getUser();

  if (user && user.termsPending) {
    /* Se muestra el modal. */
    const modal = $("#ims-terms-modal");
    modal.modal("show");
    modal.on("hidden.bs.modal", () => modal.remove());

    /* Acción al aceptar los términos. */
    $("#ims-accept-terms-btn").click(() => {
      showLoading();

      sendAsJson({
        url: "api-accept-terms",
        data: { userData: user },
        success: (data) => {
          if (data && data.status === "OK") {
            modal.modal("hide");
          }
        },
        complete: hideLoading,
      });
    });
  }
}
